var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var PublicInfo = /** @class */ (function (_super) {
    __extends(PublicInfo, _super);
    function PublicInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve public site info
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/public-info/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    PublicInfo.prototype.find = function () {
        return this.rawFind().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve public site info
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/public-info/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    PublicInfo.prototype.rawFind = function () {
        return this.client.request({
            method: 'GET',
            url: '/public-info',
        });
    };
    PublicInfo.TYPE = 'public_info';
    return PublicInfo;
}(BaseResource));
export default PublicInfo;
//# sourceMappingURL=PublicInfo.js.map